import { createApp } from 'vue';
import { createPinia } from 'pinia';
import axios from 'axios';
import { uniqueId } from 'lodash-es';

import App from './App.vue';
import router, { initializeNavPages } from './router';

// Create app
const app = createApp(App);

// Use plugins
const pinia = createPinia();
app.use(pinia);
app.use(router);

// Initialize nav pages after pinia is ready
initializeNavPages();

// Global properties
app.config.globalProperties.$http = axios;
app.config.globalProperties.$uid = uniqueId;
app.config.globalProperties.$wait = (ms: number) => new Promise((r) => setTimeout(r, ms));

// Mount
app.mount('#app');

export { app };
